import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {User} from 'interfaces';
import {Flex, Text, Icon} from 'components/UIKit';
import {FocusTrap} from 'components/FocusTrap';
import {SellerInformation} from '../SellerInformation';
import {ListingSummary} from '../ListingSummary';
import {ListingShop, ContactTrackingData} from '../../types';
import * as locales from './locales';
import styles from './Contact.scss';
import {ContactForm} from './ContactForm';

export interface ContactModalProps {
  authenticityToken: string;
  user?: User;
  show: boolean;
  shop: ListingShop;
  onClose?: any;
  isOwnStore: boolean;
  contactTracking: ContactTrackingData;
}

export interface ContactModalState {
  success: boolean;
}

function NOOP() {}

class ContactModalComponent extends React.Component<
  ContactModalProps & WithI18nProps,
  ContactModalState
> {
  state: ContactModalState = {success: false};

  handleCloseClick = (event) => {
    const {onClose = NOOP} = this.props;

    this.setState({success: false});

    onClose(event);
  };

  handleSuccess = () => this.setState({success: true});

  handleShimKeydown = () => {};

  handleDialogClick = (event) => event.stopPropagation();

  render() {
    const {success} = this.state;
    const {i18n, show, shop, user, isOwnStore, contactTracking, authenticityToken} = this.props;

    const showBio = Boolean(shop.sellerInformation);

    const formProps = {
      show,
      shop,
      user,
      isOwnStore,
      contactTracking,
      authenticityToken,
    };

    return (
      <FocusTrap active={show}>
        {(focusRef) => (
          <aside
            ref={focusRef}
            onClick={this.handleCloseClick}
            onKeyDown={this.handleShimKeydown}
            className={classNames(styles.Shim, {[styles.Showing]: show})}
          >
            <div className={styles.Dialog} onClick={this.handleDialogClick}>
              <Flex
                className={styles.Header}
                wrapperComponent="header"
                justifyContent="space-between"
                alignItems="center"
              >
                <Text type="h5" text={i18n.translate('contactSeller')} resetMargin component="h2" />
                <Icon
                  role="button"
                  size={24}
                  icon="close"
                  onClick={this.handleCloseClick}
                  className={styles.Close}
                  asButton
                />
              </Flex>
              <div className={styles.Content}>
                <ContactForm
                  onSuccess={this.handleSuccess}
                  onCancel={this.handleCloseClick}
                  {...formProps}
                />
                <div className={classNames(styles.Sidebar, {[styles.GreatSuccess]: success})}>
                  {showBio && <SellerInformation inline sellerInfo={shop.sellerInformation} />}
                  <ListingSummary hideTags hideBorder listing={shop} />
                </div>
              </div>
            </div>
          </aside>
        )}
      </FocusTrap>
    );
  }
}

export const ContactModal = withI18n({
  fallback: locales.en,
  id: 'ListingContact',
})(ContactModalComponent);
